import { motion } from "framer-motion";
import Reveal from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Who we are",
    body: "DMAB Solutions is a business consultancy and software studio, working as an embedded extension of your team, small, senior and accountable, turning complex requirements into dependable systems.",
    image:
      "https://images.pexels.com/photos/13219418/pexels-photo-13219418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    num: "02",
    title: "Our mission",
    body: "To make great technology accessible to growing businesses. We cut through jargon, favour proven tools over hype, and deliver software that is measured by the outcomes it creates, not the lines of code it contains.",
    image:
      "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBJVCUyMGNvbnN1bHRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg1MDE0MjA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "03",
    title: "Why teams choose us",
    body: "Transparent communication, fixed and honest scoping, and a genuine long term partnership. From the first workshop to years of ongoing support, we stay invested in the systems we build and the businesses they power.",
    image: null,
  },
];

export default function Manifesto() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 lg:py-40 border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-20 md:mb-28">
          <div className="mb-5 flex items-center gap-3">
            <span className="h-px w-12 bg-[#00F0FF]" />
            <span className="text-sm uppercase tracking-[0.25em] text-[#00F0FF]">
              About DMAB
            </span>
          </div>
          <h2 className="font-display font-bold tracking-tighter text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            A studio built on craft, clarity and trust.
          </h2>
        </Reveal>

        <div className="space-y-24 md:space-y-36">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.num}
              data-testid={`manifesto-chapter-${i}`}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              <div className="lg:col-span-6 [direction:ltr]">
                <Reveal>
                  <div className="flex items-start gap-6">
                    <span className="font-display text-7xl md:text-8xl lg:text-[9rem] font-black leading-none text-stroke">
                      {c.num}
                    </span>
                    <div className="pt-2 md:pt-4">
                      <h3 className="font-display text-3xl md:text-4xl font-bold text-white">
                        {c.title}
                      </h3>
                      <p className="mt-5 text-lg font-light text-[#94A3B8] leading-relaxed max-w-lg">
                        {c.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              </div>

              <div className="lg:col-span-6 [direction:ltr]">
                {c.image ? (
                  <Reveal delay={0.15}>
                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden rounded-2xl border border-white/10"
                    >
                      <img
                        src={c.image}
                        alt={c.title}
                        className="h-[320px] md:h-[420px] w-full object-cover"
                      />
                    </motion.div>
                  </Reveal>
                ) : (
                  <Reveal delay={0.15}>
                    <div className="grid grid-cols-3 gap-4">
                      {[
                        { k: "10+", v: "Years combined experience" },
                        { k: "100%", v: "Senior professionals" },
                        { k: "7/7", v: "Business operational support" },
                      ].map((stat) => (
                        <div
                          key={stat.k}
                          className="rounded-2xl border border-white/10 bg-[#0C1322] p-5 md:p-7"
                        >
                          <div className="font-display text-3xl md:text-5xl font-black text-[#00F0FF]">
                            {stat.k}
                          </div>
                          <div className="mt-3 text-xs md:text-sm text-[#94A3B8] leading-snug">
                            {stat.v}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Reveal>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
